// extracted by mini-css-extract-plugin
export var active = "pagination-module--active--24741";
export var disabled = "pagination-module--disabled--8606d";
export var pagination = "pagination-module--pagination--8c6dc";
export var paginationItem = "pagination-module--paginationItem--be503";